import React, { Component } from 'react';
import Constants from '../../../../definitions/constants';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import toastr from 'toastr';

import TextBox from './textBox';

class FreeTextList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      addItemText: "",
      editId: null,
      editedValue: null
    };
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(prevState.editId != this.state.editId && this.state.editId != null && this.editItemInput) {
      this.editItemInput.focus();      
    }
    
    if(!prevState.showOverlay && this.state.showOverlay) {
      InterfaceTooling.bringObjectEditorInputIntoView();
    }
  }
  
  handleOnChangeTopControls = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    this.setState({
      searchText: value
    });
  };

  isValidValue = (value,id) => {
    let trimedValue = value ? value.trim() : value;
    if(trimedValue == "") {
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(this.props.noEmptyTextLocale,"");
      return false;
    }
    else if(this.props.values.filter(item => (id !=item.id || id == null)
      && trimedValue.toUpperCase() == item[this.props.valueAccesor].toUpperCase()
      && !item.isDeleted).length>0) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(this.props.noRepeatTextLocale,"");
      return false;
    }
    return true;
  };

  handleClickEdit = (event) => {
    let itemValue = event.currentTarget.dataset.value;
    let itemId = event.currentTarget.dataset.id;
    this.setState({   
      showOverlay: true,   
      editId: itemId,
      editedValue: itemValue
    });
  };

  handleChangeEdit = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    this.setState({
      editedValue: value
    });
  };

  handleCancelEdit = (event) => {
    this.setState({
      showOverlay: false,
      editId: null,
      editedValue: null
    });
  };

  handleSaveEditItem = (event) => {
    if(this.isValidValue(this.state.editedValue, this.state.editId)) {
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        editId: null,
        editedValue: null
      });   
    }     
  };

  handleOnEnterEditItem = (event) => {
    if(this.editItemSaveButton) {
      this.editItemSaveButton.click();      
    }   
  };
  
  handleAddButtonClick = (event) => {
    if(this.addItemInput) {
      this.addItemInput.focus();
    }
  };

  handleCancelAdd = (event) => {
    this.setState({
      showOverlay: false,
      addItemText: ""
    });
  };

  handleChangeAddItem = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    let showOverlay = !value ? false : true;
    this.setState({
      showOverlay: showOverlay,
      addItemText: value
    });    
  };

  handleSaveAddItem = (event) => {
    if(this.isValidValue(this.state.addItemText, null)) {
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        addItemText: ""
      });
    }
  };

  handleOnEnterAddItem = (event) => {
    if(this.addItemSaveButton) {
      this.addItemSaveButton.click();
    }  
  };

  render() {
    const {
      className,
      values,
      onChange,
      labelLocale,
      addTextLocale,
      searchTextLocale,
      noEmptyTextLocale,
      noRepeatTextLocale,
      additionalControls,
      valueAccesor,
      hideList,
      dataType,
      showQuantity,
      formatter,
      handleExcelButton
    } = this.props;
    const dataPath = this.props["data-path"];
    return (
      <div className={"custom-input free-text-list" + (className ? " " + className : "") + (hideList ? " free-text-list-hide" : "") + (this.state.showOverlay ? " free-text-list-overlay" : "")}>
        {this.state.showOverlay && (<div className="free-text-list-overlay-item"></div>)}
        <div className="free-text-list-label">
          {labelLocale}
          {(showQuantity ? " (" + (values ? values.filter(item => !item.isDeleted).length : 0) + ")" : "")}
          {!hideList && (<i className="fas fa-plus-circle" onClick={this.handleAddButtonClick}/>)}
          {!hideList && (<i className="fas fa-file-excel" onClick={handleExcelButton}/>)}
          {additionalControls}
        </div>
        {!hideList && (
          <TextBox 
            className="top_controls_search"
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            value={this.state.searchText}
            onChange={this.handleOnChangeTopControls}
            labelLocale={searchTextLocale}
          />
        )}
        {!hideList && (
          <div className="free-text-list-list-wrapper">
            {values && values.map((item,i) => {
                if(item.isDeleted || (this.state.searchText!="" && 
                item[this.props.valueAccesor].toUpperCase().indexOf(this.state.searchText.toUpperCase()) == -1)) {
                  return null;
                }
                if(item.id && item.id == this.state.editId) {
                  return (
                    <div key={i} className="free-text-list-list-item free-text-list-list-item-edit">
                      <div className="free-text-list-list-item-inner">
                        <TextBox
                          className="free-text-list-list-edit-item"
                          styleType={Constants.interface.inputs.styleType.OUTLINED}
                          onChange={this.handleChangeEdit}
                          onKeyEsc={this.handleCancelEdit}
                          onKeyEnter={this.handleOnEnterEditItem}
                          value={this.state.editedValue}
                          data-id={item.id}
                          type={Constants.interface.inputs.type.TEXT}
                          labelLocale={""}
                          ref={(input) => { this.editItemInput = input; }}
                          dataType={dataType}
                        />
                      </div>
                      <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-edit">
                        <i 
                          ref={(input) => { this.editItemSaveButton = input; }}
                          className="fas fa-save"
                          data-index={i}
                          data-id={item.id}
                          data-value={this.state.editedValue}
                          data-freetextlist={"true"}
                          data-path={dataPath}
                          onClick={this.handleSaveEditItem}                      
                        />         
                        <i className="fas cancel-action fa-times-circle" onClick={this.handleCancelEdit}/>
                      </div>
                    </div>
                  );
                }
                else {
                  return (
                    <div key={i} className="free-text-list-list-item">
                      <div className="free-text-list-list-item-inner">{formatter ? formatter(item[this.props.valueAccesor]) : item[this.props.valueAccesor]}</div>
                      <div className="free-text-list-list-item-action-buttons">
                        <i 
                          className="fas fa-edit"
                          onClick={this.handleClickEdit}
                          data-id={item.id}
                          data-value={item[this.props.valueAccesor]}
                        />
                        <i 
                          className="fas delete-action fa-trash"                          
                          data-id={item.id}
                          data-index={i}
                          data-delete={"true"}
                          data-freetextlist={"true"}
                          data-path={dataPath}
                          onClick={onChange} 
                        />
                      </div>
                    </div>
                  );           
                }
            })}
            <div className="free-text-list-list-item free-text-list-list-item-add">
              <div className="free-text-list-list-item-inner">
                <TextBox 
                  ref={(input) => { this.addItemInput = input; }}
                  className="free-text-list-list-add-item"
                  styleType={Constants.interface.inputs.styleType.OUTLINED}
                  onChange={this.handleChangeAddItem}
                  value={this.state.addItemText}
                  type={Constants.interface.inputs.type.TEXT}
                  labelLocale={addTextLocale}                  
                  onKeyEsc={this.handleCancelAdd}           
                  onKeyEnter={this.handleOnEnterAddItem}
                  dataType={dataType}
                />
              </div>
              {this.state.addItemText!="" && (
                <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-add">
                  <i 
                    ref={(input) => { this.addItemSaveButton = input; }}
                    className="fas fa-save"
                    data-freetextlist={"true"}
                    data-value={this.state.addItemText}
                    data-path={dataPath}
                    onClick={this.handleSaveAddItem}   
                  />
                  <i 
                    className="fas cancel-action fa-times-circle"
                    onClick={this.handleCancelAdd}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default FreeTextList;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/freeTextList.jsx